import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Bicycle: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m607.06 477.58-161-275c-3.34-5.71-2.61-13.08 2.21-18.07 2.86-2.96 6.89-4.51 11.01-4.51h98.29c18.26 0 33.78 6.07 44.88 17.55 10.4 10.76 16.12 25.84 16.12 42.45h-30c0-18.79-11.59-30-31-30h-72.41l132.62 226.53c8.37 14.3 3.57 32.68-10.73 41.05z' />
    <path d='m615 600c-74.44 0-135-60.56-135-135s60.56-135 135-135 135 60.56 135 135-60.56 135-135 135zm0-240c-57.9 0-105 47.1-105 105s47.1 105 105 105 105-47.1 105-105-47.1-105-105-105z' />
    <path d='m165 600c-74.44 0-135-60.56-135-135s60.56-135 135-135 135 60.56 135 135-60.56 135-135 135zm0-240c-57.9 0-105 47.1-105 105s47.1 105 105 105 105-47.1 105-105-47.1-105-105-105z' />
    <path d='m360 480h-200c-5.75 0-11-3.29-13.5-8.46-2.51-5.18-1.83-11.33 1.74-15.84l142.38-180c2.84-3.6 7.18-5.69 11.76-5.69h202.62c8.28 0 15 6.72 15 15s-6.72 15-15 15h-195.36l-118.65 150h169.01c8.28 0 15 6.72 15 15s-6.72 15-15 15z' />
    <path d='m360 240h-120v-30h90c16.57 0 30 13.43 30 30z' />
    <path d='m480 341.02-105 138.98h-45l108-133.02c9.95-13.25 28.76-15.92 42-5.97z' />
  </IconBase>
));

Bicycle.displayName = 'Bicycle';

export default Bicycle;
